import e from "./_Hash.js";
import r from "./_ListCache.js";
import t from "./_Map.js";
var a = e, h = r, i = t;
function s() {
  this.size = 0, this.__data__ = {
    hash: new a(),
    map: new (i || h)(),
    string: new a()
  };
}
var _ = s;
export {
  _ as default
};
//# sourceMappingURL=_mapCacheClear.js.map
